import Layout from '../../components/layout/layout.component';
import ForgotPassword from '../../components/forgot-password/forgot-password.component';

const ForgottenPage = () => (
  <Layout>
    <ForgotPassword />
  </Layout>
);

export default ForgottenPage;